import React from "react";
import PresentationSection from "../../components/Investor/Presentation.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const Presentation = () => {
  return (
    <>
      <MetaComponent
        title="Aptech Investor presentations."
        desc="Get all details on Aptech's investor presentation, latest news, investor communication policy, financial results and annual reports here."
        keywords="Aptech Investor presentations, Investor patterns, Aptech shareholder patterns."
      />
      <PresentationSection />
    </>
  );
};

export default Presentation;
